// extracted by mini-css-extract-plugin
export default {"title":"PaymentSchemeDetails_title__Mh4Vv","total":"PaymentSchemeDetails_total__rWfN8","pay":"PaymentSchemeDetails_pay__oCuHV","edit":"PaymentSchemeDetails_edit__e3Y8a"};